import { DotLegalAlert, DotLegalDialog, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import useTransferLegalEntityDocumentDialogHooks from "./TransferLegalEntityDocumentDialog.hooks";
import { useTranslation } from "../../../localization/useTranslation";
import { Trans } from "react-i18next";

export interface ITransferLegalEntityDocumentDialogProps {
    onDialogClose: () => void;
    legalEntityId: string;
    documentId: string;
    onTransfered: () => void;
    isGroupEntity: boolean;
}

function TransferLegalEntityDocumentDialog(props: ITransferLegalEntityDocumentDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, legalEntities, saveModel, setSaveModel, transferDocument, validation, isTransferring } =
        useTransferLegalEntityDocumentDialogHooks(props);

    return (
        <DotLegalDialog
            buttonOkText={translateString("move")}
            header={translateString("transferToAnotherLegalEntity")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={() => transferDocument()}
            size="sm"
            inProgress={isTransferring}
        >
            <DotLegalAlert
                marginBottom={4}
                warningText={
                    <Trans i18nKey="transferDocumentWarning" values={{ legalEntity: legalEntities?.find((x) => x.id === props.legalEntityId)?.name }}></Trans>
                }
            ></DotLegalAlert>
            <DotLegalSelect
                options={legalEntities?.filter((x) => x.id !== props.legalEntityId)}
                onChange={(value) => {
                    if (value) {
                        let temp = { ...saveModel };
                        temp.toLegalEntityId = value;
                        temp.toLegalEntity = legalEntities?.find((x) => x.id === value)?.name ?? "";
                        setSaveModel(temp);
                    }
                }}
                label={translateString("legalEntity")}
                noOptionsLabel={translateString("noOptions")}
                isLoading={isLoading}
                disableClearable
                selectedItem={saveModel.toLegalEntityId}
                errorText={validation?.getErrorsForDisplay("toLegalEntityId")}
            />
        </DotLegalDialog>
    );
}

export default TransferLegalEntityDocumentDialog;
